import { EquipmentTable } from '~/scenes/PeopleModule/components/Tabs/EquipmentTab/EquipmentTable';

export const EquipmentTab = () => {
  return <EquipmentTable />;
};
